export enum DATE_FORMAT {
    YEAR_FOUR_DIGITS = 'yy',
    YEAR_FOUR_DIGITS_MONTH = 'yy-mm',
    YEAR_FOUR_DIGITS_MONTH_DAY = 'yy-mm-dd',
}